<template>
  <div class="relative">
    <!-- Dropdown toggle button -->
    <button
      class="flex items-center px-3 py-3 w-full bg-white rounded-md border toggle-btn border-input"
      @click="onClickToggle"
    >
      <span class="mr-4 text-xs md:text-md">{{ sTitle }}</span>
      <svg
        class="absolute right-2 w-5 h-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <!-- Dropdown menu -->
    <div
      v-if="isShowDrop"
      class="absolute left-0 py-2 w-full bg-white rounded-md border shadow-xl border-line cs-dropdown"
      :class="[{active: isShowAni}]"
      style="z-index: 10"
      v-click-outside="onClickOutside"
    >
      <div v-for="(item, index) in items" :key="index">
        <template v-if="'line' === item.data">
          <div class="w-full border-b border-line"></div>
        </template>
        <template v-else>
          <button class="px-3 py-3 w-full text-left" @click.stop="onClickItem(item)">
            {{ item.title }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import vClickOutside from "@baiguangteng/vue3-click-outside";

const emit = defineEmits(["onClick"]);

const props = defineProps({
  alwaysTitle: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: false,
  },
  items: {
    type: Object,
    required: true,
  },
});

let currentItem = ref({title: "", data: null});
let isShowAni = ref(false);
let isShowDrop = ref(false);

const sTitle = computed(() => {
  console.log("lifecycle - computed setup");

  let title = "";

  if (props.alwaysTitle) {
    title = props.alwaysTitle;
  } else if (props.title) {
    title = props.title;
  } else if (currentItem && currentItem.value) {
    title = currentItem.value.title;
  }

  return title;
});

onMounted(() => {
  if (!props.alwaysTitle && props.items.length) {
    currentItem.value.title = props.items[0].title;
    currentItem.value.data = props.items[0].data;
  }
});

const onClickToggle = () => {
  isShowDrop.value = !isShowDrop.value;
  setTimeout(() => {
    isShowAni.value = !isShowAni.value;
  }, 50);
};

function onClickOutside() {
  if (isShowAni.value) {
    isShowAni.value = false;
    isShowDrop.value = false;
  }
}

const onClickItem = (item) => {
  currentItem.value = item;

  onClickOutside();
  emit("onClick", item);
};
</script>

<style lang="scss" scoped>
.cs-dropdown {
  opacity: 0.2;
  transition: opacity 0.15s;

  & > div {
    transition: background-color 0.2s;

    &:hover {
      background-color: rgb(245, 245, 245);
    }
  }

  &.active {
    opacity: 1;
  }
}

.toggle-btn {
  height: 40px;
}
</style>
